import * as groupSettings from './group-settings';

export {
  // This sets up appContext.admin.groupSettings.getGroupSettings()
  // to serve as an example of putting namespaces inside .admin
  groupSettings,
};
